import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, TripCustomerfetchData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { ThreeDRotationOutlined } from '@mui/icons-material';
import { Discount } from '@mui/icons-material';
import { FaHtml5, FaWeight } from 'react-icons/fa';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Make sure axios is installed and imported
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CircularProgress from '@mui/material/CircularProgress';



const truncate2 = (num) => Math.trunc(num * 100) / 100;

const AdditionalOrderCreate = () => {
  const { id } = useParams();

  const history = useHistory();
  const { isAuthenticated, companyId, userId, customerid, token, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
    }
  }, [isAuthenticated, token, logout]);

  const [data, setData] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [customerName, setCustomerName] = useState('');
  const [rate, setRate] = useState('');
  const [discount, setDiscount] = useState(''); // Correct 
  const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
  const [GSTRate, setGSTRate] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [tripdate, setTripdate] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [qty, setQty] = useState('');
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [CustName, setCustName] = useState("");
  const [SaleRemarks, setSaleRemarks] = useState("");
  const [items, setitems] = useState('');
  const [isReturnsale, setisReturn] = useState('');
  const [Bundle, setBundle] = useState('');
  const [Pieces, setPieces] = useState('');

  const [pricetype, setpricetype] = useState('');
  const [orderDate, setOrderDate] = useState('');
  const [Route, setRoute] = useState("");
  const [routeId, setrouteId] = useState("");

  useEffect(() => {
    fetchtableData();
  }, []);

  const fetchtableData = async () => {
    try {
      setLoading(true);
      const response = await fetchData('RoutePriceTypeApi', `/${id}`, token);

      if (response.responseCode === '1111') {
        setData(response.response_data);

        const Route = response.response_data[0].name;
        const pricetype = response.response_data[0].pricetype;
        const routeId = response.response_data[0].id; // Retrieve routeId
        const orderDate = response.response_data[0].orderDate;

        setpricetype(pricetype);
        setRoute(Route);
        setOrderDate(orderDate);
        setrouteId(routeId);
        console.log(response);

      }
    } catch (error) {
      console.error('Error fetching Item Details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  // Function to fetch routes
  const fetchRouteTypes = async () => {
    try {
      const response = await fetchData('RouteApi', `/${companyId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(route => ({
          value: route.id,
          label: route.name
        }));
        setRouteOptions(options);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };

  // Function to handle route change and fetch customers based on selected route
  const handleRouteWiseCustomerChange = async (selectedOption) => {
    setSelectedRoute(selectedOption);
    setSelectedCustomer(null); // Reset customer selection

    try {
      const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
      if (response.responseCode === '1111') {
        const customerOptions = response.response_data.map(customer => ({
          value: customer.id,
          label: customer.name + ' ' + customer.addressLine1 + ' ' + customer.customerCode
        }));
        setCustomerOptions(customerOptions);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  // Handle customer selection
  const handleCustomerSelect = (selectedOption) => {
    setSelectedCustomer(selectedOption);
  };

  useEffect(() => {
    fetchRouteTypes();
  }, []);


  const [categoryId, setCategoryId] = useState('');
  const [productCategoryId, setPCategoryId] = useState('');
  const [itemId, setItemId] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [pcategoryOptions, setPCategoryOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPCategory, setSelectedPCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  //Product catgory
  useEffect(() => {
    const fetchPCategoryTypes = async () => {
      try {
        const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);

        if (response.responseCode === '1111') {
          const dataArray = response.response_data;
          const options = response.response_data.map(pcat => ({
            value: pcat.id,
            label: pcat.name
          }));
          setPCategoryOptions(options);
          setPCategoryId(dataArray[0].id);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchPCategoryTypes();
  }, [companyId, token]);

  const handlePCategoryChange = (selectedOption) => {
    setSelectedPCategory(selectedOption);
    fetchCategoryTypes(selectedOption.value);
    // fetchItemsTypes(selectedOption.value);
    setPCategoryId(selectedOption.value);
    setSelectedItem(null);
  };


  //catgory
  const fetchCategoryTypes = async (productCategoryId) => {
    try {
      const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(cat => ({
          value: cat.id,
          label: cat.name
        }));
        setCategoryOptions(options);
        //setCategoryId(dataArray[0].id);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };


  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    fetchItemsTypes(selectedOption.value);
    setCategoryId(selectedOption.value);
    setSelectedItem(null);
  };

  const fetchItemsTypes = async (categoryId) => {
    try {
      const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(item => ({
          value: item.id,
          label: item.name
        }));
        setItemOptions(options);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const [QtyBundle, setQtyBundle] = useState('');

  const handleItemChange = async (selectedOptions) => {
    setSelectedItem(selectedOptions);
    const ItemID = selectedOptions.value;
    setItemId(ItemID);

    try {
      const response = await fetchData('RoutePriceTypeApi', `/${routeId}/${ItemID}`, token);

      if (response && response.response_data && response.response_data.length > 0) {
        let itemFound = false;

        // Iterate through each category in response_data
        response.response_data.forEach(category => {
          if (category.Items && category.Items.length > 0) {
            category.Items.forEach(item => {
              if (!itemFound) {
                console.log(`Processing item: ${item.Name}`);
                // Process each item here
                // Extract numeric part from Weight

                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                const numericWeight = parseFloat(Weight);
                setRate(Rate);
                setGSTRate(GSTRate);
                setBundle(Bundle);
                setQtyBundle(QtyBundle);
                setNewItem((prevItem) => ({
                  ...prevItem,
                  weight: numericWeight, // Add weight to the newItem state
                  rate: Rate,
                  GSTRate: GSTRate,
                  //Bundle: Bundle,
                  Bundle: Bundle ?? 0, // Set Bundle to 0 if it's null
                  QtyBundle: QtyBundle ?? 0,
                }));
                itemFound = true; // Set itemFound to true when an item is processed
              }
            });
          }
        });

        if (!itemFound) {
          console.error('No items found in the response data');
        }
      } else {
        console.error('Invalid response structure');
      }
    } catch (error) {
      console.error('Error fetching item rate:', error);
    }
  };


  const [newItem, setNewItem] = useState("");



  const handleQtyChange = (e) => {
    const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (input.length <= 10) { // Limit input length to avoid overflow
      setQty(input); // Update state with cleaned input

      const quantity = parseInt(input) || 0; // Parse input to integer, default to 0 if NaN
      // Calculate other derived values based on your logic
      const gstAmount = (rate * GSTRate) / 100;
      const totalAmount = rate * quantity;
      const totalPlusGst = totalAmount + gstAmount;
      const totalQuantity = newItem.weight * quantity;

      // Update state with the new calculated values
      setNewItem((prevItem) => ({
        ...prevItem,
        quantity: quantity,
        totalAmount: totalAmount,
        GSTRate: GSTRate,
        gstAmount: gstAmount,
        totalPlusGst: totalPlusGst,

        discount: discount,
        totalQuantity: totalQuantity,
      }));
    }
  };



  useEffect(() => {
    const quantity = parseInt(qty) || 0;
    const gstAmount = (rate * GSTRate) / 100;
    const totalAmount = rate * quantity;
    const totalPlusGst = totalAmount + gstAmount;
    const bundle = Bundle;
    //const pieceCount = quantity % newItem.Bundle;
    setNewItem((prevItem) => ({
      ...prevItem,
      rate: rate,
      totalAmount: totalAmount,
      gstAmount: gstAmount,
      totalPlusGst: totalPlusGst,
      discount: discount, // Ensure correct reference
      Bundle: bundle,
      //pieces: pieceCount,
    }));
  }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

  const [itemList, setItemList] = useState([]);

  const defaultItem = {
    Id: '',
    Name: '',
    quantity: 1,
    GSTRate: 0,
    rate: 0,
    totalAmount: 0,
    totalPlusGst: 0,
    discount: 0,
    weight: 0,
    totalQuantity: 0,
    rateperkg: 0,
    TotalAmtperkgwise: 0,
    GstPer: 0,
    gstAmount: 0,
    TaxableAmount: 0,
    Bundle: 0,
    Pieces: 0,
    singlediscount: 0,
  };

  const AddtoListdata = (e) => {
    e.preventDefault();
    if (qty > 0) {
      const quantity = parseInt(qty);
      //const bundleSize = parseInt(newItem.Bundle);
      const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0
      const discountPerPiece = newItem.discountPerPiece || 0; // Default to 0 if DiscountPerPiece is null or undefined
      const discount = parseInt(discountPerPiece) || 0;
      // Calculate number of bundles and remaining pieces
      // Check if bundleSize is valid (not null or 0)
      const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
      const pieceCount = bundleSize ? quantity % bundleSize : 0;

      let RateAfterDiscount = 0;

      if (discount > 0) {
        RateAfterDiscount = rateperkg - discount;
      }
      else {
        RateAfterDiscount = rate;
      }
      // Your existing calculations
      // const rateperkg = rate / newItem.weight;
      const rateperkg = rate;
      const totalQuantity = newItem.weight * quantity;
      const totalAmount = rate * quantity;
      const TotalAmtperkgwise = rateperkg * totalQuantity;
      const TaxableAmount = truncate2(((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate));
      const gstAmount = truncate2((TaxableAmount * GSTRate) / 100);
      const GstPer = (gstAmount / TaxableAmount) * 100;
      const totalPlusGst = Math.round(TaxableAmount + gstAmount);

      const updatedItem = {
        ...newItem,
        Name: selectedItem.label,
        Id: selectedItem.value,
        quantity: quantity,
        rate: rate,
        GSTRate: GSTRate,
        totalAmount: totalAmount,
        totalPlusGst: totalPlusGst,
        discount: discount,
        totalQuantity: totalQuantity,
        rateperkg: rateperkg,
        TotalAmtperkgwise: TotalAmtperkgwise,
        TaxableAmount: TaxableAmount,
        gstAmount: gstAmount,
        GstPer: GstPer,
        Bundle: numBundles,
        Pieces: pieceCount,
        QtyBundle: QtyBundle,
      };

      // Updating state
      setItemList([...itemList, updatedItem]);

      // Resetting newItem state
      setNewItem({
        Id: '',
        Name: '',
        quantity: 1,
        GSTRate: 0,
        rate: 0,
        totalAmount: 0,
        totalPlusGst: 0,
        discount: 0,
        weight: 0,
        totalQuantity: 0,
        rateperkg: 0,
        TotalAmtperkgwise: 0,
        GstPer: 0,
        gstAmount: 0,
        TaxableAmount: 0,
        Bundle: 0,
        pieces: 0,
      });

      // Resetting other state variables
      setNewItem({ ...defaultItem });
      setSelectedItem('');
      setQty('');
      setRate('');
      setGSTRate(0);
      setBundle('');
    }
  };
  const handleDiscountChange = (e, index) => {
    const value = parseFloat(e.target.value) || 0;
    const updatedItems = [...itemList];
    updatedItems[index].singlediscount = value;

    const TotalQuantity = updatedItems[index].totalQuantity || 0;
    const rateperkg = updatedItems[index].rateperkg || 0;
    const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
    const TotalAmtperkgwise = rateperkg * TotalQuantity;
    const TaxableAmount = truncate2((((rateperkg - value) * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0);
    // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
    const gstAmount = truncate2((TaxableAmount * updatedItems[index].GSTRate / 100) || 0);
    const GstPer = (TaxableAmount !== 0) ? (gstAmount / TaxableAmount * 100) : 0;
    const totalPlusGst = Math.round(TaxableAmount + gstAmount);

    updatedItems[index].totalPlusGst = totalPlusGst;
    updatedItems[index].discount = value;
    updatedItems[index].gstAmount = gstAmount;
    updatedItems[index].GstPer = GstPer;
    updatedItems[index].TaxableAmount = TaxableAmount;
    setItemList(updatedItems);
  };



  const handleQuantityChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...itemList];
    const quantity = parseInt(value, 10);
    updatedItems[index].quantity = quantity;

    let bundleSize = 0;
    const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
    const bag = updatedItems[index].BagWeight || 0;
    const bagweight = updatedItems[index].weight || 0;
    let BagWeight = 0;

    if (bag > 0) {
      BagWeight = bag;
      bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
    } else if (bagweight > 0) {
      BagWeight = bagweight;
      bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
    }

    const rateperkg = updatedItems[index].rateperkg || 0;

    const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
    const pieceCount = bundleSize ? quantity % bundleSize : 0;

    // Calculate Total Quantity (Kgs)
    const TotalQuantity = BagWeight * quantity;
    updatedItems[index].totalQuantity = TotalQuantity;

    const RateAfterDiscount = rateperkg - DiscountPerPiece;
    updatedItems[index].RateAfterDiscount = RateAfterDiscount;

    const TaxableAmount = truncate2(((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0);
    updatedItems[index].TaxableAmount = TaxableAmount;

    const gstAmount = truncate2((TaxableAmount * updatedItems[index].GSTRate / 100) || 0);
    updatedItems[index].gstAmount = gstAmount;

    const totalPlusGst = Math.round(TaxableAmount + gstAmount);
    updatedItems[index].totalPlusGst = totalPlusGst;

    const totalAmount = RateAfterDiscount * quantity;
    updatedItems[index].totalAmount = totalAmount;

    updatedItems[index].Bundle = numBundles;
    updatedItems[index].Pieces = pieceCount;

    console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values

    setItemList(updatedItems); // This should trigger a re-render with the updated state
  };



  const submitData = async (e) => {
    e.preventDefault();
    try {
      const itemsToSave = itemList.map(item => ({
        ItemId: item.Id,
        // CustomerId: customerId || 0, // Ensure CustomerId is set to 0 if not provided
        CustomerId: selectedCustomer?.value || 0, // Using selectedCustomer value
        CompanyId: companyId,
        CategoryId: categoryId,
        ProductCategoryId: productCategoryId,
        rate: item.Rate,

        Quantity: item.quantity,
        Discount: item.discount ? item.discount : 0,
        BilledDate: new Date(),
        CreatedBy: userId,
        CreatedDate: new Date(),
        RatePerKg: item.rateperkg,
        DiscountPerPiece: item.singlediscount ? item.singlediscount : 0,
        RateAfterDiscount: (item.rateperkg - item.singlediscount),
        TotalQty: item.totalQuantity,
        BagWeight: item.weight,
        CGSTAmt: (item.gstAmount / 2),
        SGSTAmt: (item.gstAmount / 2),
        GSTAmt: item.gstAmount,
        TaxableAmt: item.TaxableAmount,
        NetAmt: item.totalPlusGst,
        Bundle: item.Bundle,
        Pieces: item.Pieces

      }));

      const saleorderdata = {
        TripId: id,
        CustomerId: selectedCustomer?.value || 0, // Using selectedCustomer value
        OrderDate: orderDate,
        SaleRemarks: SaleRemarks,
        RId: selectedRoute.value,
        RName: selectedRoute.label,
        CreatedBy: userId,
        CompanyId: companyId,
        CreatedDate: new Date(),
        OrderType: 2,
        CustName: CustName,
      };

      const CreateData = {
        SaleOrder: saleorderdata,
        SaleOrderDetails: itemsToSave,
      };

      // Show a confirmation dialog before submitting the order
      const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
      if (confirmOrder) {
        postData('AddOrderAPI', CreateData, token)
          .then((response) => {
            if (response.response === '1111') {
              const SaleOrderid = response.SaleOrderId;
              history.push(`/TriporderedIndexs/${id}`);
            }
          })
          .catch((error) => {
            console.error('SaleOrder Create error:', error);
          });
      }
    } catch (error) {
      console.error('Submit error:', error);
    }
  };

  const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const openConfirmDialog = (index) => {
    setItemToDeleteIndex(index);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setItemToDeleteIndex(null);

  };

  const handleDelete = () => {
    if (itemToDeleteIndex !== null) {
      const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
      setItemList(updatedItemList);
      closeConfirmDialog();
    }
  };
  const handleRateChange = (e, index) => {
    const newRate = parseFloat(e.target.value) || 0;

    // Update the item at the specified index
    setItemList((prevItemList) => {
      return prevItemList.map((item, i) => {
        if (i === index) {
          const quantity = item.quantity;
          const totalQuantity = item.weight * quantity;
          const totalAmount = newRate * totalQuantity;

          const TaxableAmount = ((newRate - item.singlediscount) * totalQuantity * 100) / (100 + item.GSTRate);
          const gstAmount = (TaxableAmount * item.GSTRate) / 100;
          const totalPlusGst = TaxableAmount + gstAmount;

          return {
            ...item,
            rateperkg: newRate,
            totalQuantity: totalQuantity,
            TaxableAmount: TaxableAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            TotalAmtperkgwise: totalAmount,
            GstPer: item.GSTRate,
          };
        }
        return item;
      });
    });
  };

  // Shared select styles matching Edit page theme
  const selectStyles = {
    control: (base, state) => ({
      ...base, fontSize: '12px', minHeight: '32px', height: '32px',
      borderColor: state.isFocused ? '#6b4c7a' : '#e0d4ec',
      borderRadius: '6px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(107,76,122,0.12)' : 'none',
      '&:hover': { borderColor: '#6b4c7a' },
    }),
    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
    indicatorsContainer: (base) => ({ ...base, height: '32px' }),
    option: (base, state) => ({
      ...base, fontSize: '12px', padding: '6px 10px',
      backgroundColor: state.isSelected ? '#6b4c7a' : state.isFocused ? '#f3edf8' : 'white',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div style={{ maxWidth: '100%', backgroundColor: '#f3edf8', padding: '12px' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 12px rgba(107,76,122,0.10)', overflow: 'hidden' }}>
        {loading && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(107, 76, 122, 0.18)', backdropFilter: 'blur(3px)',
            display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
          }}>
            <div style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
              backgroundColor: 'white', borderRadius: '12px', padding: '24px 40px',
              boxShadow: '0 8px 32px rgba(107,76,122,0.18)'
            }}>
              <CircularProgress style={{ color: '#6b4c7a' }} size={36} thickness={4} />
              <span style={{ color: '#6b4c7a', fontSize: '13px', fontWeight: 600 }}>Loading...</span>
            </div>
          </div>
        )}
        <form onSubmit={submitData}>

          {/* ── Header Bar ── */}
          <div style={{
            background: 'linear-gradient(135deg, #6b4c7a 0%, #9b6dac 100%)',
            padding: '10px 16px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <div>
              <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: 'white', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                ➕ Additional Order Create
              </h2>
              <div style={{ marginTop: '2px', fontSize: '11px', color: 'rgba(255,255,255,0.8)' }}>
                Route: <strong style={{ color: 'white' }}>{Route}</strong>
                <span style={{ margin: '0 10px' }}>|</span>
                Order Date: <strong style={{ color: 'white' }}>{orderDate && new Date(orderDate).toLocaleDateString('en-GB')}</strong>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button variant="contained" type="submit" style={{
                height: '32px', fontSize: '11px', fontWeight: 700,
                backgroundColor: '#10a37f', color: 'white',
                borderRadius: '16px', textTransform: 'none',
                boxShadow: '0 2px 6px rgba(16,163,127,0.4)',
                padding: '0 14px',
              }}>
                ✓ Order Confirm
              </Button>
              <Tooltip title="Back To List">
                <Link to={`/AddtionalOrderIndex/${id}`} style={{ textDecoration: 'none' }}>
                  <Button variant="contained" style={{
                    height: '32px', fontSize: '11px', fontWeight: 700,
                    backgroundColor: 'rgba(255,255,255,0.15)', color: 'white',
                    borderRadius: '16px', textTransform: 'none',
                    border: '1px solid rgba(255,255,255,0.4)', boxShadow: 'none',
                    padding: '0 12px',
                  }}>
                    Back <ExitToAppIcon style={{ marginLeft: '3px', fontSize: '14px' }} />
                  </Button>
                </Link>
              </Tooltip>
            </div>
          </div>

          <div style={{ padding: '10px 14px' }}>

            {/* ── Customer Selection Section ── */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr 1fr',
              gap: '8px',
              marginBottom: '8px',
              padding: '10px 12px',
              backgroundColor: '#faf8fc',
              borderRadius: '8px',
              border: '1px solid #e8dff0',
            }}>
              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                  🚛 Route <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <Select
                  value={selectedRoute}
                  onChange={handleRouteWiseCustomerChange}
                  options={routeOptions}
                  placeholder="Select Route"
                  isSearchable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                  👤 Customer <span style={{ color: '#dc3545' }}>*</span>
                </label>
                <Select
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={handleCustomerSelect}
                  placeholder="Select a Customer"
                  isSearchable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                  👤 Customer Name
                </label>
                <input
                  value={CustName}
                  onChange={(e) => setCustName(e.target.value)}
                  type="text"
                  placeholder="Enter customer name"
                  style={{
                    width: '100%', height: '32px', padding: '0 10px',
                    fontSize: '12px', border: '1.5px solid #e0d4ec',
                    borderRadius: '6px', outline: 'none',
                    transition: 'border-color 0.2s', boxSizing: 'border-box',
                  }}
                  onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                  onBlur={e => e.target.style.borderColor = '#e0d4ec'}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                  📝 Remarks
                </label>
                <input
                  value={SaleRemarks}
                  onChange={(e) => setSaleRemarks(e.target.value)}
                  type="text"
                  placeholder="Enter remarks"
                  maxLength="100"
                  autoComplete="off"
                  style={{
                    width: '100%', height: '32px', padding: '0 10px',
                    fontSize: '12px', border: '1.5px solid #e0d4ec',
                    borderRadius: '6px', outline: 'none',
                    transition: 'border-color 0.2s', boxSizing: 'border-box',
                  }}
                  onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                  onBlur={e => e.target.style.borderColor = '#e0d4ec'}
                />
              </div>
            </div>

            {/* ── Add Item Section ── */}
            <div style={{
              padding: '10px 12px',
              backgroundColor: '#faf8fc',
              borderRadius: '8px',
              border: '1px solid #e8dff0',
              marginBottom: '10px',
            }}>
              <div style={{ fontSize: '10px', fontWeight: 700, color: '#6b4c7a', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '8px' }}>
                ➕ Add Item
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 110px auto', gap: '8px', alignItems: 'flex-end' }}>

                {[
                  { label: 'Category', value: selectedPCategory, onChange: handlePCategoryChange, options: pcategoryOptions, placeholder: 'Select Category' },
                  { label: 'Variant', value: selectedCategory, onChange: handleCategoryChange, options: categoryOptions, placeholder: 'Select Variant' },
                  { label: 'Variant with Bagweight', value: selectedItem, onChange: handleItemChange, options: itemOptions, placeholder: 'Select Item' },
                ].map((sel, i) => (
                  <div key={i}>
                    <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>{sel.label}</label>
                    <Select
                      value={sel.value}
                      onChange={sel.onChange}
                      options={sel.options}
                      placeholder={sel.placeholder}
                      isSearchable
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </div>
                ))}

                <div>
                  <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>QTY (Pieces)</label>
                  <input
                    value={qty} onChange={handleQtyChange} type="text" placeholder="0"
                    style={{
                      width: '100%', height: '32px', padding: '0 10px',
                      fontSize: '12px', fontWeight: 600,
                      border: '1.5px solid #e0d4ec', borderRadius: '6px',
                      textAlign: 'center', outline: 'none', boxSizing: 'border-box',
                      transition: 'border-color 0.2s',
                    }}
                    onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                    onBlur={e => e.target.style.borderColor = '#e0d4ec'}
                  />
                </div>
                <div>
                  <Button variant="contained" onClick={AddtoListdata} style={{
                    height: '32px', fontSize: '11px', fontWeight: 700,
                    backgroundColor: '#6b4c7a', color: 'white',
                    borderRadius: '6px', textTransform: 'none',
                    whiteSpace: 'nowrap', padding: '0 14px',
                    boxShadow: '0 2px 6px rgba(107,76,122,0.3)',
                  }}>
                    + Add
                  </Button>
                </div>
              </div>
            </div>

            {/* ── Items Table ── */}
            <div style={{ marginTop: '8px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(107,76,122,0.12)', border: '1px solid #e0d6e8' }}>
              <div style={{ overflowX: 'auto', maxHeight: '420px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                  <colgroup>
                    <col style={{ width: '4%' }} />   {/* Sl.No */}
                    <col style={{ width: '13%' }} />  {/* Name */}
                    <col style={{ width: '7%' }} />   {/* Qty */}
                    <col style={{ width: '7%' }} />   {/* Total Qty */}
                    <col style={{ width: '6%' }} />   {/* Bundle */}
                    <col style={{ width: '6%' }} />   {/* Pieces */}
                    <col style={{ width: '8%' }} />   {/* Rate/Kg */}
                    <col style={{ width: '7%' }} />   {/* Discount */}
                    <col style={{ width: '8%' }} />   {/* Rate After Disc */}
                    <col style={{ width: '9%' }} />   {/* Taxable Amt */}
                    <col style={{ width: '6%' }} />   {/* GST% */}
                    <col style={{ width: '8%' }} />   {/* GST ₹ */}
                    <col style={{ width: '9%' }} />   {/* Total */}
                    <col style={{ width: '5%' }} />   {/* Action */}
                  </colgroup>
                  <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                    <tr style={{ backgroundColor: '#6b4c7a' }}>
                      {[
                        { label: 'Sl', align: 'center' },
                        { label: 'Name', align: 'left' },
                        { label: 'Qty', sub: 'No.Pieces', align: 'center' },
                        { label: 'Total Qty', sub: 'Kgs', align: 'right' },
                        { label: 'Bundle', align: 'center' },
                        { label: 'Pieces', align: 'center' },
                        { label: 'Rate/Kg', sub: 'Incl.Tax', align: 'right' },
                        { label: 'Discount', align: 'right' },
                        { label: 'Rate', sub: 'After Disc.', align: 'right' },
                        { label: 'Taxable Amt', align: 'right' },
                        { label: 'GST%', align: 'center' },
                        { label: 'GST (₹)', align: 'right' },
                        { label: 'Total', align: 'right' },
                        { label: '', align: 'center' },
                      ].map((col, i) => (
                        <th key={i} style={{
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '11px',
                          padding: '10px 8px',
                          textAlign: col.align,
                          whiteSpace: 'nowrap',
                          borderRight: i < 13 ? '1px solid rgba(255,255,255,0.18)' : 'none',
                          letterSpacing: '0.3px',
                          lineHeight: '1.3',
                        }}>
                          {col.label}
                          {col.sub && <><br /><span style={{ fontSize: '9px', fontWeight: 400, opacity: 0.85 }}>{col.sub}</span></>}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {itemList.length === 0 ? (
                      <tr>
                        <td colSpan={14} style={{ textAlign: 'center', padding: '28px', color: '#aaa', fontSize: '13px', fontStyle: 'italic' }}>
                          No items added yet. Select a product above and click + Add.
                        </td>
                      </tr>
                    ) : (
                      itemList.map((item, index) => {
                        const rateAfterDisc = (item.singlediscount ?? 0) === 0
                          ? item.rateperkg
                          : (item.rateperkg - item.singlediscount);
                        const isAlt = index % 2 === 0;
                        const rowBg = isAlt ? '#faf8fc' : '#ffffff';
                        const inputStyle = {
                          width: '100%',
                          textAlign: 'right',
                          padding: '4px 6px',
                          fontSize: '11px',
                          border: '1px solid #d0c4dc',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          outline: 'none',
                          boxSizing: 'border-box',
                        };
                        return (
                          <tr key={index} style={{ backgroundColor: rowBg, borderBottom: '1px solid #ede7f3', transition: 'background 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3edf8'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = rowBg}
                          >
                            {/* Sl.No */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#6b4c7a', fontWeight: 700, borderRight: '1px solid #ede7f3' }}>
                              {index + 1}
                            </td>
                            {/* Name */}
                            <td style={{ fontSize: '12px', padding: '8px', fontWeight: 600, color: '#3d2459', borderRight: '1px solid #ede7f3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                              title={item.Name}>
                              {item.Name}
                            </td>
                            {/* Qty */}
                            <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                              <input
                                type="number"
                                value={item.quantity}
                                onChange={(e) => handleQuantityChange(e, index)}
                                min="0"
                                step="1"
                                style={inputStyle}
                              />
                            </td>
                            {/* Total Qty */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#333', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                              {Number(item.totalQuantity || 0).toFixed(2)}
                            </td>
                            {/* Bundle */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                              <span style={{ display: 'inline-block', background: '#ede7f3', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>
                                {item.Bundle ?? 0}
                              </span>
                            </td>
                            {/* Pieces */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                              <span style={{ display: 'inline-block', background: '#e8f4fd', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>
                                {item.Pieces ?? 0}
                              </span>
                            </td>
                            {/* Rate/Kg */}
                            <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                              <input
                                type="number"
                                value={item.rateperkg}
                                onChange={(e) => handleRateChange(e, index)}
                                step="0.01"
                                min="0"
                                style={inputStyle}
                              />
                            </td>
                            {/* Discount */}
                            <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                              <input
                                type="number"
                                value={(isNaN(item.singlediscount) || item.singlediscount === "") ? '0' : item.singlediscount}
                                onChange={(e) => handleDiscountChange(e, index)}
                                step="0.01"
                                min="0"
                                style={inputStyle}
                              />
                            </td>
                            {/* Rate After Discount */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#1a7a4a', fontWeight: 600, borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                              {Number(rateAfterDisc || 0).toFixed(2)}
                            </td>
                            {/* Taxable Amt */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#333', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                              {Number(item.TaxableAmount || 0).toFixed(2)}
                            </td>
                            {/* GST% */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                              <span style={{ display: 'inline-block', background: '#fff8e1', color: '#b8860b', borderRadius: '10px', padding: '1px 7px', fontWeight: 600, fontSize: '10px' }}>
                                {Number(item.GSTRate || 0).toFixed(2)}%
                              </span>
                            </td>
                            {/* GST ₹ */}
                            <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#c0392b', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                              {Number(item.gstAmount || 0).toFixed(2)}
                            </td>
                            {/* Total */}
                            <td style={{ fontSize: '12px', padding: '8px', textAlign: 'right', fontWeight: 700, color: '#2c3e50', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                              {Number(item.totalPlusGst || 0).toFixed(2)}
                            </td>
                            {/* Delete */}
                            <td style={{ padding: '6px', textAlign: 'center' }}>
                              <IconButton
                                size="small"
                                onClick={() => openConfirmDialog(index)}
                                style={{ padding: '4px', color: '#e53935', backgroundColor: '#fdecea', borderRadius: '6px' }}
                              >
                                <DeleteIcon style={{ fontSize: '16px' }} />
                              </IconButton>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                  <tfoot>
                    <tr style={{ backgroundColor: '#6b4c7a', color: 'white', fontWeight: 700 }}>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'left', borderRight: '1px solid rgba(255,255,255,0.2)', letterSpacing: '0.5px' }} colSpan="2">
                        TOTAL
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.quantity) || 0), 0)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.totalQuantity) || 0), 0).toFixed(2)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.Bundle) || 0), 0)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.Pieces) || 0), 0)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.singlediscount) || 0), 0).toFixed(2)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.TaxableAmount) || 0), 0).toFixed(2)}
                      </td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                      <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.gstAmount) || 0), 0).toFixed(2)}
                      </td>
                      <td style={{ fontSize: '13px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums', backgroundColor: '#4a2d5a' }}>
                        {itemList.reduce((acc, item) => acc + (Number(item.totalPlusGst) || 0), 0).toFixed(2)}
                      </td>
                      <td style={{ padding: '10px 8px' }}></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            {/* Delete Confirm Dialog */}
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{ style: { borderRadius: '12px', padding: '8px' } }}
            >
              <DialogTitle id="alert-dialog-title" style={{ color: '#6b4c7a', fontWeight: 700 }}>Delete Record?</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  ⚠️ Are you sure you want to delete this record permanently?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ padding: '8px 16px 16px' }}>
                <button
                  onClick={closeConfirmDialog}
                  style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600 }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600, marginLeft: '8px' }}
                >
                  Confirm
                </button>
              </DialogActions>
            </Dialog>

          </div> {/* end padding wrapper */}
        </form>
      </div>
    </div>
  );
};

export default AdditionalOrderCreate;
